import { ChangeEvent } from 'react';

import { Box } from '@core/component';
import { EDeliveryType } from '@core/type/api';

import { ProductCartActions } from './ProductCartActions';
import { SwitchAutoSavings } from './SwitchAutoSavings';
import { BudgetCalculator } from './budget-calculator';
import { ProductBudgetAndCartActionsProps } from './interface-product-show';

export const ProductBudgetAndCartActions = ({
  product,
  logisticType,
  forecastedDelivery,
  setProductCount,
  country,
  productCount,
  isAutoSavingActive,
  setIsAutoSavingActive,
}: ProductBudgetAndCartActionsProps) => {
  const productStock = product?.preorder?.preorderStock || product.currentStock;
  const switchProps =
    logisticType === EDeliveryType.STORAGE
      ? {
          isChecked: isAutoSavingActive,
          onChange: ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
            setIsAutoSavingActive(checked);
          },
        }
      : undefined;
  const productPrice =
    logisticType === EDeliveryType.STORAGE
      ? product.totalPriceWithDeal ?? product.totalPrice
      : forecastedDelivery.totalPriceWithDeal ?? forecastedDelivery.totalPrice;
  const currentCountry = logisticType === EDeliveryType.SHIPPING ? country : undefined;

  return (
    <Box paddingTop="24px" maxWidth="350px">
      <BudgetCalculator
        product={product}
        currentStock={productStock}
        productPrice={productPrice}
        logisticType={logisticType}
        setProductCount={setProductCount}
        country={currentCountry}
      />

      <ProductCartActions
        isRepeatBuyActive={
          logisticType === EDeliveryType.STORAGE ? switchProps?.isChecked : undefined
        }
        {...product}
        productCount={productCount}
        setProductCount={setProductCount}
        shippingMethod={{ shippingType: logisticType, countryIso: currentCountry }}
      />
      {logisticType === EDeliveryType.STORAGE && product.isRepeatBuy && (
        <SwitchAutoSavings {...switchProps} />
      )}
    </Box>
  );
};
